import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../reducers";
import { getRoles, createRole, updateRole, deleteRole } from "../actions";

export const useRolesState = () => {
  return useSelector((state: RootState) => state.roles);
};

export const useRolesDispatch = () => {
  const dispatch = useDispatch();
  return {
    ...bindActionCreators(
      { getRoles, createRole, updateRole, deleteRole },
      dispatch
    ),
  };
};
